import useApi from "../useApi";

const useInfoService = () => {

  const {api} = useApi()

  const userShowInfo = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'get',
      'user/media/info/'+id,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useInfoService::userShowInfo: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    userShowInfo
  }
}

export default useInfoService
